import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-reason-dialog',
  templateUrl: './reason-dialog.component.html',
  styleUrls: ['./reason-dialog.component.css'],
})
export class ReasonDialogComponent {
  public reason: string;

  constructor(private activeModal: NgbActiveModal) {}

  submitClick() {
    this.activeModal.close(this.reason);
  }
}
